import React from 'react';
import PredictPatientList from './PredictPatientList';

/**
 * Unassigned Patients View - shows only patients without assignments
 */
const PredictUnassignedPatients: React.FC = () => {
  return <PredictPatientList ownershipFilter="UNASSIGNED" />;
};

export default PredictUnassignedPatients;
